import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react'
import { connect } from 'react-redux'
import * as actions from '../redux/actions'
import rp from 'request-promise-native'
import { uri, imageBaseURL } from '../services/defaultProps'
import sendMessageWPP from '../services/sendMessageWPP'
import Header from '../components/Header'
import { FiArrowLeft } from 'react-icons/fi'
import { FaWhatsapp } from 'react-icons/fa'
import text from '../constants/Menu'
import Loader from 'react-loader-spinner'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { withWindowSizeListener } from 'react-window-size-listener'
import { useHistory } from 'react-router-dom'
import translation from '../constants/Perfil'
import '../styles/containers/Perfil.css'
import useLanguage from '../hooks/useLanguage'

const silhouettePictures = [
  {
    id: 1,
    desc: 'Silhueta triângulo ou pêra',
    image: '/assets/color/silhouette1.jpeg'
  },
  {
    id: 2,
    desc: 'Silhueta oval',
    image: '/assets/color/silhouette2.jpeg'
  },
  {
    id: 3,
    desc: 'Silhueta triângulo invertido',
    image: '/assets/color/silhouette3.jpeg'
  },
  {
    id: 4,
    desc: 'Silhueta retângulo',
    image: '/assets/color/silhouette4.jpeg'
  },
  {
    id: 5,
    desc: 'Silhueta ampulheta',
    image: '/assets/color/silhouette5.jpeg'
  },
  {
    id: 6,
    desc: 'Silhueta oito',
    image: '/assets/color/silhouette6.jpeg'
  }
]

const PerfilGridWithoutSizeListener = ({ photos, windowSize: { windowWidth } }) => {
  const renderPhotos = useCallback(() => {
    const { push } = useHistory()

    const [imageWidth, setImageWidth] = useState(0)
    const imageRef = useRef(null)

    const navigateToSlider = index => {
      push('/perfil/carousel', {
        initialPhoto: index,
        photos
      })
    }

    /*
      listen the window width, when the window width changes, update
      the image width to calculate the new height based on the new width

      obs: similar to aspect-ratio property
    */
    useEffect(() => {
      setImageWidth(imageRef.current.offsetWidth)
    }, [windowWidth])

    return photos.map((photo, index) => {
      return (
        <div ref={imageRef} key={photo} className='perfil-grid-item'
          onClick={() => navigateToSlider(index)} style={{ height: 4 * imageWidth / 3 }} >
          <LazyLoadImage src={photo} effect='blur'
            width='100%'
            height='100%'
            style={{
              objectFit: 'cover',
              objectPosition: 'center'
            }} />
        </div>
      )
    })
  }, [photos, windowWidth])

  return (
    <div className='perfil-grid-container'>
      {renderPhotos()}
    </div>
  )
}

const PerfilGrid = withWindowSizeListener(PerfilGridWithoutSizeListener)

const Perfil = props => {
  const { push } = useHistory()

  const language = useLanguage()
  const [loadingReqService, setLoadingReqService] = useState(false)

  const imagesToShow = useMemo(() => {
    const { userProfile, userStyle, silhouetteId } = props.user

    if (userProfile && userProfile.length > 0) return userProfile.map(img => img.image)

    if (silhouetteId || (userStyle && userStyle.styleImages)) {
      let images = []

      const silhouette = silhouettePictures.find(silhouette => silhouette.id === silhouetteId)

      silhouetteId && images.push(silhouette.image)
      userStyle.styleImages && userStyle.styleImages.forEach(img => images.push(imageBaseURL + img.image))

      return images
    }

    return []
  }, [])

  const requestService = () => {
    const reqServiceMessage = (consultant) => ([
      `Olá ${consultant}. Vi no MOSTY sobre o serviço análise de silhueta e fiquei interessada em saber mais sobre o serviço, você pode me explicar?`,
      `Hello ${consultant}. I saw on MOSTY about the silhouette analysis service and was interested to know more about the service, can you explain me?`,
      `Hola, ${consultant}. Vi en MOSTY sobre el servicio de análisis de silueta y estaba interesado en saber más sobre el servicio, ¿me puede explicar?`
    ])

    rp({
      uri: `${uri}/user`,
      method: 'GET',
      headers: {
        Authorization: props.token
      },
      json: true
    }).then(({consultantName, consultantPhone}) => {
      sendMessageWPP(
        consultantPhone,
        reqServiceMessage(consultantName)[language]
      )
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      setLoadingReqService(false)
    })

    setLoadingReqService(true)
  }

  return (
    <div className='perfil-screen-container'>
      <Header language={language} />
      <div className='perfil-screen-title'>
        <FiArrowLeft onClick={() => push('/')}
          size={24} color='var(--primary)' className='perfil-screen-goback' />
        <p>{text.perfil[language]}</p>
      </div>
      {imagesToShow.length > 0 ? (
        <PerfilGrid photos={imagesToShow} />
      ) : (
        <div className='perfil-screen-notconfigured'>
          {!loadingReqService ? (
            <div className='perfil-request-service'>
              <p>{translation.notConfig[language]}</p>
              <p className='perfil-request-message'>
                <span onClick={requestService} className='perfil-request-service-link'>
                  {translation.notConfSendLink[language]}
                </span>
                <span>{translation.notConfSendMessage[language]}</span>
                <FaWhatsapp color='var(--primary)' size={20} style={{ marginLeft: 8, position: 'relative', top: 4 }} />
              </p>
            </div>
          ) : (
            <Loader
              type='TailSpin'
              color='#6d357b'
              height='50'
              width='50'
            />
          )}
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(Perfil)



// WEBPACK FOOTER //
// ./src/containers/Perfil.js